var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header-container",class:{
    'about-start': _vm.$route.name === 'page-about',
    'aoubt-2-has-played': _vm.about2hasPlayed,
    'aoubt-4-has-played': _vm.about4hasPlayed,
    'home-start': _vm.$route.name === 'page-home',
    'home-mobile': _vm.$bowser.mobile && _vm.$route.name === 'page-home',
    'home-transition-end': _vm.$bowser.mobile && _vm.$route.name === 'page-home' && _vm.homeTransitionEnd,
    hidden: _vm.normalHidden,
    whiteShow: _vm.whiteShow,
    menuOpened: _vm.$store.state.subMeunSwitch,
    mobileMemberDetailShow: _vm.$store.state.mobileMemberDetailShow
  }},[_c('div',{ref:"normal",staticClass:"header__inner"},[_c('router-link',{staticClass:"logo",class:{
        menuOpened: _vm.$store.state.subMeunSwitch
      },attrs:{"tag":"div","to":{
        path: '/'
      }}},[_c('div',{staticClass:"main-logo"}),_c('div',{staticClass:"sub-logo"})]),(_vm.$route.meta.isHiddenMenu !== true)?_c('div',{staticClass:"menu",class:{
        clicked: _vm.$store.state.subMeunSwitch
      },on:{"click":_vm.onClick}},[_vm._m(0),_vm._m(1)]):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu__text"},[_c('p',[_vm._v("menu")]),_c('p',[_vm._v("close")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu__icon"},[_c('i'),_c('i')])}]

export { render, staticRenderFns }